<form (ngSubmit)="createExportProjectFiles()">
  <section>
    <p i18n
      >Alle Projektdateien der ausgewählten Veranstaltungen werden in eine ZIP-Datei exportiert. Die Ordnerstruktur folgt dem folgenden
      Format: <code>[Veranstaltungs-ID]/[Abgabe-ID].json</code>.</p
    >
  </section>

  <section>
    <button
      mat-raised-button
      type="submit"
      color="primary"
      [disabled]="isLoading || selectedEvents.length === 0"
      [dtOverlayProgress]="isLoading"
    >
      <mat-icon>download</mat-icon><ng-container i18n>Exportieren</ng-container></button
    >
  </section>
</form>
